<template>
  <div class="changeenterprise">
    <div class="header">
      <enterprise-header></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:506px;background:#ffffffcf;border-radius: 4px;" class="box">
          <div class="validationsuccee" style="margin-left:48px;margin-right:48px">
            <p style="font-size:24px;text-align: center;color:#000000;margin-top:61px">
              企业选择
            </p>
            <p style="font-size:14px;color:#6681A0;margin-top:11px">
              选择已有企业
            </p>
            <ul style="text-align: center;padding-top:15px;max-height: 400px;overflow-y: auto;">
              <li v-for="(item, index) in erpriseList" :key="index"
                :class="[item.enterpriseId === enterpriseId ? 'active' : '']" @click="changeli(item)">
                <p :title="item.enterpriseName">
                  {{ item.enterpriseName }}
                </p>
                <span v-if="item.status == 0" style="vertical-align: top;color:#aaa;margin-left:20px">审核中</span>
                <span v-if=" item.status == 1 && item.joinStatus == 1 && item.isEnabled == 1 "
                  style="vertical-align: top;color:#aaa;margin-left:20px">启用</span>
                <span v-if=" item.status == 1 && item.joinStatus == 1 && item.isEnabled == 0 "
                  style="vertical-align: top;color:#aaa;margin-left:20px">禁用</span>
                <span v-if="item.status == 1 && item.joinStatus == 0"
                  style="vertical-align: top;color:#aaa;margin-left:20px">审核中</span>
                <span v-if="item.status == 2" style="vertical-align: top;color:#aaa;margin-left:20px">驳回</span>
                <span v-if="item.status == 4" style="vertical-align: top;color:#aaa;margin-left:20px">禁用</span>
              </li>
            </ul>
            <p style="font-size:14px;text-align: right;width:400px;padding-bottom:48px;margin-top: 20px;">
              您还可以选择<span style="color:var(--theme-color);font-size:14px;cursor: pointer;" @click="join">创建新企业</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enterpriseService from "@/CommonDP/service/enterprise-service";
import EnterpriseHeader from "./components/userEnterHeader";
export default {
  components: {
    EnterpriseHeader
  },
  data() {
    return {
      yanzheng: require("@/CommonDP/assets/enterprise/验证成功.png"),
      erpriseList: [],
      enterpriseId: ""
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      enterpriseService.usergetEnterpriseList().then((res) => {
        if (res.result === "0") {
          console.log(res.data, "res.data");
          this.erpriseList = res.data;
        }
      });
    },
    changeli(item) {
      this.enterpriseId = item.enterpriseId;
      if (item.status === 0 || item.status === 2) {
        // 审核中创建的 // 企业被驳回
        const { href } = this.$router.resolve({ path: "/creationcomplete", query: { id: item.enterpriseId }});
        window.open(href, "_blank");
      } else if (item.status === 1) {
        if (item.joinStatus === 0) {
          // 审核中加入
          const { href } = this.$router.resolve({
            path: "/noenterprise",
            query: { showtype: 3, name: item.enterpriseName }
          });
          window.open(href, "_blank");
        } else if (item.joinStatus === 1) {
          // 通过
          if (item.isEnabled === 1) {
            enterpriseService
              .userselectEnterprise(item.enterpriseId)
              .then((res) => {
                if (res.result === "0") {
                  this.$store.dispatch("setUnauthorized", 1);
                  this.$store.dispatch("setEnterpriseId", item.enterpriseId);
                  this.$store.dispatch("setIsTrial", item.isTrial);
                  this.$router.push({ name: "mainMg" });
                }
              })
              .catch(() => {});
          } else {
            // 禁用
            const { href } = this.$router.resolve({
              path: "/noenterprise",
              query: { showtype: 2, name: item.enterpriseName }
            });
            window.open(href, "_blank");
          }
        }
      } else if (item.status === 4) {
        const { href } = this.$router.resolve({
          path: "/noenterprise",
          query: { showtype: 4, name: item.enterpriseName }
        });
        window.open(href, "_blank");
      }
    },
    join() {
      const { href } = this.$router.resolve({ path: "/enterprisepage", query: { pagetype: "1" }});
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.changeenterprise {
  min-width: 900px;
  width: 100%;
  min-height: 768px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    // text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      li {
        cursor: pointer;
        width: 400px;
        height: 46px;
        line-height: 46px;
        margin-bottom: 20px;
        color: var(--theme-color);
        font-size: 16px;
        background: #eff5fe;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 270px;
          margin: 0 auto;
          display: inline-block;
        }
      }
      .active {
        border: 1px solid;
      }
    }
  }
}
</style>
